<div class="multi-select-container">
  <nz-select
    #multiSelect
    [compareWith]="compareFn"
    [nzMaxTagCount]="5"
    [nzAllowClear]="!selectDefault"
    [nzShowArrow]="true"
    [nzBackdrop]="true"
    [nzStatus]="hasError() ? 'error' : ''"
    [nzDisabled]="disable"
    [nzDropdownMatchSelectWidth]="false"
    [nzShowSearch]="filteredOptions?.length > 10"
    [nzMaxTagPlaceholder]="tagPlaceHolder"
    [nzMode]="isMultiSelect?'multiple' : 'default'"
    [nzPlaceHolder]="placeholder"
    [ngModel]="isMultiSelect ? selectedItems : selectedItems[0]"
    (ngModelChange)="toggleSelection($event)"
  >
    @for (item of filteredOptions; track getNestedValue(item, valueKey)) {
      <nz-option [nzLabel]="getNestedValue(item, displayKey)" [nzValue]="item"></nz-option>
    }
  </nz-select>
  <ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
</div>



